// extracted by mini-css-extract-plugin
module.exports = {"button":"expanding-plus-button_button__qtu92","open-icon":"expanding-plus-button_open-icon__c8LQB","close-icon":"expanding-plus-button_close-icon__K4f2I"};